import Vue from 'vue';

Vue.component('configurator-version-select', {
    data() {
        return {
            selectionExpanded: false,
            selectedIndex: 0,
            version: null,
            edition: null,
            color: null,
            originalVersions: null,
        };
    },

    watch: {
        /**
         * Set edition when index is updated.
         *
         * @returns {Void}
         */
        selectedIndex(value) {
            this.updateVersion();
        },

        /**
         * Send event on version change.
         *
         * @returns {Void}
         */
        version(value) {
            if (!value) return;

            // Check for disabled versions before emitting
            this.checkDisabledVersions();
            // Only emit if version is still available after checking disabled versions
            if (this.edition.field_commerceVersions.includes(value)) {
                EventBus.$emit('configurator-set-version', value);
                EventBus.$emit('configurator-set-disclaimer-version', value);
            }
        },
    },

    computed: {
        makeBoxModelActive() {
            return this.selectionExpanded ? 'active' : '';
        },
    },

    mounted() {
        EventBus.$on('configurator-set-edition', (edition) => {
            this.edition = edition;
            this.originalVersions = [...edition.field_commerceVersions];
            this.selectedIndex = 0;
            if (this.color) {
                this.checkDisabledVersions();
            }
            this.updateVersion();
        });

        EventBus.$on('configurator-set-color', (color) => {
            this.color = color;
            if (this.originalVersions) {
                this.checkDisabledVersions();
                this.updateVersion();
            }
        });

        EventBus.$on('configurator-request-version', () => {
            if (!this.version || !this.edition) return;
            if (!this.edition.field_commerceVersions.includes(this.version))
                return;

            EventBus.$emit('configurator-set-version', this.version);
            EventBus.$emit('configurator-set-disclaimer-version', this.version);
        });
    },

    methods: {
        checkDisabledVersions() {
            if (
                !this.color ||
                !this.color.field_disableRangeEdition_liiytphn ||
                !this.edition
            )
                return;

            const currentVersionHandle =
                this.version?.field_version_versionHandle;

            // Only reset versions if we're not coming from edition change
            if (!this.selectedIndex) {
                this.edition.field_commerceVersions = [
                    ...this.originalVersions,
                ];
            }

            const arrayColorsWithEditions = JSON.parse(
                this.color.field_disableRangeEdition_liiytphn,
            ).map((colorWithEdition) => Object.values(colorWithEdition));

            arrayColorsWithEditions.forEach((colorWithEditions) => {
                const [disabledEdition] = colorWithEditions[0].split('-', 2);
                const disabledVersion = colorWithEditions[0].substring(
                    colorWithEditions[0].indexOf('-') + 1,
                );

                if (
                    disabledEdition.toLowerCase() ===
                    this.edition.title.toLowerCase()
                ) {
                    this.selectedIndex = 0;

                    const filteredVersions =
                        this.edition.field_commerceVersions.filter(
                            (version) =>
                                version.field_version_versionHandle !==
                                disabledVersion,
                        );

                    this.edition.field_commerceVersions = filteredVersions;

                    // If current version is disabled, reset to first available
                    if (currentVersionHandle === disabledVersion) {
                        this.updateVersion();
                    }

                    if (this.edition.field_commerceVersions.length === 1) {
                        this.selectionExpanded = false;
                    }
                }
            });
        },

        setNoPointerTitle(edition) {
            return edition.field_commerceVersions.length === 1
                ? 'configurator__select-title--no-pointer'
                : null;
        },

        toggleSectionExpanded(edition) {
            if (edition.field_commerceVersions.length > 1) {
                this.selectionExpanded = !this.selectionExpanded;
                return;
            }
            return null;
        },

        toggleSwitchButton(index) {
            return this.selectedIndex == index ? 'switch-button--selected' : '';
        },
        /**
         * Resets version to the first one.
         *
         * @returns {Void}
         */
        resetVersion() {
            if (this.originalVersions) {
                this.edition.field_commerceVersions = [
                    ...this.originalVersions,
                ];
            }
            this.selectedIndex = 0;
            this.updateVersion();
            // Only check disabled versions if we have a color selected
            if (this.color) {
                this.checkDisabledVersions();
            }
        },

        /**
         * Sets current selected version from version index or null if this edition doesn't have versions.
         * @returns {Void}
         */
        updateVersion() {
            if (this.edition.field_commerceVersions.length) {
                this.version =
                    this.edition.field_commerceVersions[this.selectedIndex];

                return;
            }
            this.version = null;
        },
    },
});
